export default "__VITE_ASSET__D9ZpDOz9__"